export const OUT = true;
export const IN = false;
export const REACHED = 1;
export const SETTLED = 2;
